// project imports
import samplePage from './sample-page';
import other from './other';
import pages from './pages';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [samplePage]
};

export default menuItems;
